import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "quality-stats" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "quality-stats__season-menu" }
const _hoisted_4 = { class: "quality-stats__season-label" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "table table-responsive-lg quality-stats__table" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { span: "1" }),
  /*#__PURE__*/_createElementVNode("col", {
    span: "1",
    style: {"width":"25%"}
  }),
  /*#__PURE__*/_createElementVNode("col", { span: "1" }),
  /*#__PURE__*/_createElementVNode("col", { span: "1" }),
  /*#__PURE__*/_createElementVNode("col", { span: "1" }),
  /*#__PURE__*/_createElementVNode("col", { span: "1" })
], -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-nowrap" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_vit_dropdown = _resolveComponent("vit-dropdown")!
  const _component_icon = _resolveComponent("icon")!
  const _component_vit_tab = _resolveComponent("vit-tab")!
  const _component_vit_tabs = _resolveComponent("vit-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.labels.errorMessage), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.labels.dateLabel) + ": " + _toDisplayString(new Date().toString().substring(0, 15)), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.labels.seasonLabel) + ":", 1),
            _createVNode(_component_vit_dropdown, {
              ref: "dropdown",
              label: _ctx.currentSeasonLabel,
              inline: "",
              light: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasonData, (s) => {
                  return (_openBlock(), _createBlock(_component_dropdown_item, {
                    key: s.seasonId,
                    label: s.description,
                    onClick: ($event: any) => (_ctx.changeSeason(s)),
                    selected: _ctx.season === s.description
                  }, null, 8, ["label", "onClick", "selected"]))
                }), 128)),
                (_ctx.loadingList)
                  ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_ctx.commodities && _ctx.commodities.barley && _ctx.commodities.barley.dataSorted.length)
            ? (_openBlock(), _createBlock(_component_vit_tabs, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodities, (tab, t) => {
                    return (_openBlock(), _createBlock(_component_vit_tab, {
                      key: `qt#${t}`,
                      title: tab.label
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "mt-3 button",
                          onClick: ($event: any) => (_ctx.exportXlsx(tab))
                        }, _toDisplayString(_ctx.labels.exportLabel), 9, _hoisted_5),
                        _createElementVNode("table", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                onClick: ($event: any) => (_ctx.sortColumn(t, 'grade')),
                                class: "quality-stats__column text-nowrap"
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.labels.gradeLabel) + " ", 1),
                                _createVNode(_component_icon, {
                                  name: "icn-sort-arrow",
                                  class: _normalizeClass(`quality-stats__sort-arrow quality-stats__sort-arrow-${_ctx.getSortDir(tab, 'grade')}`)
                                }, null, 8, ["class"])
                              ], 8, _hoisted_8),
                              _createElementVNode("th", {
                                onClick: ($event: any) => (_ctx.sortColumn(t, 'site')),
                                class: "quality-stats__column"
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.labels.siteLabel) + " ", 1),
                                _createVNode(_component_icon, {
                                  name: "icn-sort-arrow",
                                  class: _normalizeClass(`quality-stats__sort-arrow quality-stats__sort-arrow-${_ctx.getSortDir(tab, 'site')}`)
                                }, null, 8, ["class"])
                              ], 8, _hoisted_9),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.columns, (column) => {
                                return (_openBlock(), _createElementBlock("th", {
                                  key: `th-${column.key}`,
                                  class: "text-right quality-stats__column",
                                  onClick: ($event: any) => (_ctx.sortColumn(t, column.key))
                                }, [
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(column.label), 1),
                                  _hoisted_12,
                                  _createElementVNode("span", _hoisted_13, [
                                    _createVNode(_component_icon, {
                                      name: "icn-sort-arrow",
                                      class: _normalizeClass(`quality-stats__sort-arrow quality-stats__sort-arrow-${_ctx.getSortDir(tab, column.key)}`)
                                    }, null, 8, ["class"]),
                                    _createTextVNode(" " + _toDisplayString(column.unit), 1)
                                  ])
                                ], 8, _hoisted_10))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.dataSorted, (data) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `${data.grade}-${data.site}`
                              }, [
                                _createElementVNode("td", null, _toDisplayString(data.grade), 1),
                                _createElementVNode("td", null, _toDisplayString(data.siteDescription), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.columns, (column) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: `${column.key}-${data.grade}-${data.site}`,
                                    class: "text-right"
                                  }, _toDisplayString(data.qualities.find(x => x.testType === column.key).result.toFixed(2)), 1))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["title"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_loading_spinner, { key: 1 }))
        ], 64))
  ]))
}